import React, { FC, ElementType } from "react"
import { Route, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { RootState } from "../store/reducers"

const AppRoute: FC<{
  path: string
  component: ElementType
  layout: ElementType
  authenticate?: boolean
  isAuthenticated: boolean
  exact?: boolean
}> = ({
  component: Component,
  layout: Layout,
  authenticate = false,
  isAuthenticated,
  path,
  exact = true,
  ...rest
}) => {
  if (authenticate && !isAuthenticated) {
    return <Redirect to="/feed" />
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout {...matchProps}>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  )
}

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps)(AppRoute)
